import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "luxe_consent_dismissed";

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      // Pages can opt out by setting <body data-no-consent> — the
      // Nisky Auto PWA at /adminpwa does this because the banner
      // would otherwise cover the full-viewport PWA iframe.
      if (document.body.getAttribute("data-no-consent") !== null) return;
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch (_) {
      // localStorage unavailable (private mode, etc.) — don't show
    }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(STORAGE_KEY, "1"); } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-between gap-4 px-5 py-3.5"
      style={{
        background: "rgba(10,10,10,0.92)",
        borderTop: "1px solid rgba(138,138,138,0.2)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
      }}
      role="region"
      aria-label="Privacy notice"
    >
      <p className="text-xs leading-relaxed" style={{ color: "rgba(255,255,255,0.6)" }}>
        By visiting this site you agree to our{" "}
        <Link to="/privacy" onClick={dismiss} className="underline hover:text-white transition-colors" style={{ color: "#8A8A8A" }}>
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link to="/terms" onClick={dismiss} className="underline hover:text-white transition-colors" style={{ color: "#8A8A8A" }}>
          Terms of Service
        </Link>
        .
      </p>
      <button
        onClick={dismiss}
        aria-label="Dismiss"
        className="shrink-0 p-1.5 rounded hover:bg-white/10 transition-colors"
        style={{ color: "rgba(255,255,255,0.45)" }}
      >
        <X size={15} />
      </button>
    </div>
  );
}
